import React, { useContext, useEffect, useState } from "react";

import "./Argentina.css";
import CommonTourCard from "../../common_component/common_tour_card/Common_Tour_Card";
import Common_Title from "../../common_component/common_title/Common_Title";
import City_Scroller from "../../home/city_container/City_Container";
import { Context } from "../../../utils/context";
import { useParams } from "react-router-dom";
import { SwiperSlide } from "swiper/react";
import Swiper from "swiper";
import { Navigation } from "swiper/modules";

function Argentina() {
  const [data, setData] = useState([]);
  const [packages, setPackage] = useState([]);

  const { getData } = useContext(Context);
  const { id } = useParams();
  const locationId = Number(id);

  const getDataAll = async () => {
    const response = await getData("/master/location/");
    setData(response?.data || []);
  };

  const getPackageAll = async () => {
    const response = await getData(`/master/packagebylocation/${id}/`);
    setPackage(response?.data || []);
  };

  useEffect(() => {
    getDataAll();
    getPackageAll();
  }, [id]);

  // ✅ CONTINENT MAP (SAME AS HOME 🔥)
  const continentMap = [
    { id: 1, title: "Europe" },
    { id: 2, title: "Asia" },
    { id: 3, title: "North America" },
    { id: 4, title: "South America" },
    { id: 5, title: "Africa" },
    { id: 6, title: "Australia" },
    { id: 7, title: "Antarctica" },
  ];

  return (
    <section className="argentina_section">
      <City_Scroller data={data} />

      {/* ✅ LOOP ALL CONTINENTS */}
      {continentMap.map((continent) => {
        const filteredPackages = packages.filter(
          (item) => item.package_type === continent.id,
        );

        if (filteredPackages.length === 0) return null;

        return (
          <div className="europe" key={continent.id}>
            <div className="container">
              <div className="destination_title">
                <Common_Title title={continent.title} />
              </div>

              <div className="row">
                {filteredPackages.map((tour, index) => (
                  <div className="col-lg-6 col-md-6 mb-4" key={index}>
                    <CommonTourCard
                      title={tour?.title}
                      img={tour?.images?.[0]?.image}
                      location={tour?.location?.name}
                      duration={tour?.duration}
                      places={tour?.places_covered}
                      activity={tour?.activities_count}
                      data={tour}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        );
      })}
    </section>
  );
}

export default Argentina;
